import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12a6 6 0 1 0 12 0a6 6 0 1 0 -12 0","key":"svg-0"}],["path",{"d":"M7 12h11","key":"svg-1"}]]

/**
 * IconGenderAgender
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ2VuZGVyLWFnZW5kZXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgMTJhNiA2IDAgMSAwIDEyIDBhNiA2IDAgMSAwIC0xMiAwIiAvPgogIDxwYXRoIGQ9Ik03IDEyaDExIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/gender-agender
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGenderAgender = createReactComponent('outline', 'gender-agender', 'GenderAgender', __iconNode);

export default IconGenderAgender;